import { css } from 'styled-components'
import { GridProps } from './Grid.types'

export const getGapUtils = (props: GridProps) => {
  if (props.rowGap) {
    return css`
      row-gap: ${props.rowGap};
    `
  }
  if (props.columnGap) {
    return css`
      column-gap: ${props.columnGap};
    `
  }
  if (props.gap) {
    return css`
      gap: ${props.gap};
    `
  }
}
